import { render, staticRenderFns } from "./CouponList.vue?vue&type=template&id=80aef34a"
import script from "./CouponList.vue?vue&type=script&lang=ts"
export * from "./CouponList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports